import { useRef, useMemo } from 'react';
import styled from '@emotion/styled';
import { mergeProps, useFocusRing, useTableColumnHeader } from 'react-aria';
import { useHeaderColumnContext } from './SettingsTable';

export function FamilySettingsTableUsersColumnHeader(props) {
  const { column, state } = useHeaderColumnContext();
  const ref = useRef();
  const tableColumnHeader = useTableColumnHeader({ node: column }, state, ref);
  const focusRing = useFocusRing();

  const columnKeysJoined = useMemo(() => {
    return state.collection.columns
      .map((column) => {
        return column.key;
      })
      .sort()
      .join(',');
  }, [state.collection.columns]);

  return (
    <S.TableColumnHeader
      {...mergeProps(tableColumnHeader.columnHeaderProps, focusRing.focusProps)}
      colSpan={column.colspan}
      ref={ref}
      data-columns={columnKeysJoined}
      data-type={column.key}
    >
      {column.rendered}
    </S.TableColumnHeader>
  );
}

function S() {}
FamilySettingsTableUsersColumnHeader.S = S;

S.TableColumnHeader = styled.th`
  outline: none;
  text-align: start;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &[data-columns='actions,enabled,localUsername,name,role'] {
    &[data-type='name'] {
      width: 34%;
    }

    &[data-type='role'] {
      width: 14%;
    }

    &[data-type='localUsername'] {
      width: 26%;
    }

    &[data-type='enabled'] {
      width: 18%;
    }

    &[data-type='actions'] {
      width: 8%;
    }
  }

  &[data-columns='actions,enabled,name,role'] {
    &[data-type='name'] {
      width: 44%;
    }

    &[data-type='role'] {
      width: 14%;
    }

    &[data-type='enabled'] {
      width: 28%;
    }

    &[data-type='actions'] {
      width: 14%;
    }
  }
`;
